import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_DELETE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseDelete($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        delete
      }
    }
  }
`);
